import { generateGetSignedUrl } from 'api/action';
import * as Sentry from '@sentry/react';

export const downloadFromS3 = async (
  bucket: string,
  filePath: string
): Promise<void> => {
  const url = await generateGetSignedUrl({
    bucket,
    key: filePath,
  });
  const response = await fetch(url);
  const blob = await response.blob();
  const downloadUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = downloadUrl;
  anchor.download = decodeURIComponent(filePath).split('/').pop() ?? 'report';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(downloadUrl);
};

export const useDownloadFromS3 = (
  bucket: string,
  filePath: string,
  setLoading: (loading: boolean) => void
) => {
  const download = async () => {
    try {
      setLoading(true);
      await downloadFromS3(bucket, filePath);
    } catch (err) {
      Sentry.captureException(err);
    } finally {
      setLoading(false);
    }
  };
  return download;
};
